const getFileExtension = (file) => {
  return file.split(".").pop();
};

const sortFiles = (files) => {
  return files.sort((a, b) => {
    const dateOne = new Date(a.date);
    const dateTwo = new Date(b.date);

    return dateTwo - dateOne;
  });
};

const generateFullPath = (relativePath) => {
  return process.env.VUE_APP_BASE_URL + relativePath;
};

const readData = (data) => {
  return new Promise((res) => {
    const fileReader = new FileReader();
    fileReader.onload = (e) => res(e.target.result);
    fileReader.readAsDataURL(data);
  });
};

const isValidHttpURL = (string) => {
  let url;

  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }

  return url.protocol === "http:" || url.protocol === "https:";
};

export {
  getFileExtension,
  sortFiles,
  generateFullPath,
  readData,
  isValidHttpURL,
};
